import service from './service';
import { UrlBuilder } from './url-builder';

export const addDocumunet = async (companyId, payload) => {
  const builder = new UrlBuilder(`/library/company/${companyId}/add-document`);

  const response = await service.put(builder.toString(), payload);

  if (response.status === 200) {
    return response.data;
  }

  return undefined;
};

export const listDocuments = async (companyId) => {
  const builder = new UrlBuilder(`/library/company/${companyId}/list-document`);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return [];
};

export const documentView = async (companyId, payload) => {
  const builder = new UrlBuilder(`/library/company/${companyId}/get-document`);

  const response = await service.post(builder.toString(), payload);

  if (response.status === 200) {
    return response.data;
  }

  return undefined;
};

export const documentDelete = async (companyId, documentId) => {
  const builder = new UrlBuilder(`/library/company/${companyId}/delete-document/${documentId}`);

  const response = await service.remove(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return undefined;
};
